export default "__VITE_ASSET__mRMhFT0u__"